import {
    DEALERBANKNAME_SUCCESS,
    DEALERBANKNAME_FAILED,
    RESET_DEALERBANKNAME,
    LOADING_DEALERBANKNAME,
    NETWORK_ERROR_DEALERBANKNAME
} from "../types/index";
import { dealerServices } from "../../config/axios";

const resetDealerBankName = () => {
    return { type: RESET_DEALERBANKNAME };
};

const dealerBankName = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERBANKNAME });
    await dealerServices
        .post("getBankNameList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerBankNamesuccess(res.data));
                    break;
                default:
                    dispatch(dealerBankNameFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERBANKNAME,
                payload: err
            });
        });
};
function dealerBankNamesuccess(data) {
    return {
        type: DEALERBANKNAME_SUCCESS,
        payload: data
    };
}
function dealerBankNameFailed(data) {
    return {
        type: DEALERBANKNAME_FAILED,
        payload: data
    };
}

export { resetDealerBankName, dealerBankName };
